const baseURL = 'https://catalogo.grupoperezs.com/';

export default baseURL;
